<template>
  <div class="flex sm:h-screen sm:content-center sm:items-center">
    <div class="container mx-auto">
      <div class="container mx-auto w-full sm:max-w-lg">
        <div class="bg-white sm:rounded-lg sm:shadow-xl">
          <div class="w-full px-6 flex items-center mb-4 pt-4">
            <router-link class="text-2xl text-blue-500 mr-2" to="/login">
              <i class="far fa-chevron-circle-left"></i>
            </router-link>
            <div class="text-3xl font-bold text-black">
              Password Reset
            </div>
          </div>

          <div class="px-6 mb-4">
            <div class="bg-blue-700 mb-8 p-4 text-white" v-if="status !== null">
              <span>{{ status }}</span>
            </div>
            <p class="mb-6 text-left">
              Enter your email address and we will send you a password reset
              link.
            </p>
            <div class="block pb-4" data-children-count="1">
              <label class="block text-gray-700 font-bold mb-2" for="email"
                >Email Address</label
              >
              <input
                class="bg-grey-100 appearance-none border rounded w-full py-3 px-4 text-black leading-tight focus:outline-none"
                type="email"
                name="email"
                id="email"
                v-model="email"
                required
                @keyup.enter="reset()"
              />
            </div>
          </div>

          <div
            class="bg-grey-100 border-t border-b border-grey-300 rounded-b-lg px-6 py-4"
          >
            <div class="flex justify-between items-center">
              <button
                class="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded py-2 px-6 focus:outline-none mx-auto"
                v-on:click="reset()"
              >
                <span v-if="!resetting">Send Password Reset Link</span>
                <span v-if="resetting"
                  ><i class="fa fa-circle-notch fa-spin logging-in"></i
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer
        class="container mx-auto w-full sm:max-w-md mt-10 text-center text-gray-500 text-sm"
      >
        <span class="block sm:inline"
          >&copy;2016-{{ new Date().getFullYear() }} Live Storms Media, LLC.
        </span>
        <span class="block sm:inline">All rights reserved.</span>
      </footer>
    </div>
  </div>
</template>

<script>
import * as Config from "@/config";
import axios from "axios";

export default {
  name: "PasswordReset",
  data() {
    return {
      email: null,
      resetting: false,
      status: null
    };
  },
  methods: {
    async reset() {
      const api = axios.create({
        baseURL: "https://geocode.arcgis.com"
      });
      delete api.defaults.headers.common["Authorization"];

      this.resetting = true;
      try {
        const res = await api.post(Config.apiPath + "/api/password/email", {
          email: this.email
        });
        this.status = res.data.status;
      } catch (e) {
        console.log(e);
        this.$swal("Oops!", "Something went wrong.", "error");
      }
      this.resetting = false;
    }
  }
};
</script>
